import {
  Button,
  useRecordContext,
  useTranslate,
  useRefresh,
} from 'react-admin';
import { useState } from 'react';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Tooltip } from '@mui/material';
import {
  AddCertifiedUsersModal,
  type CertifiedUsersCategory,
} from './AddCertifiedUsersModal';
import { buildExistingCertifiedUsers } from '../../../utils/certifiedUsersAssignments';
import type { CertifiedAssetRow, ExistingCertifiedUser, AssigneeChoice } from '../../../utils/certifiedUsersAssignments';

export const AddCertifiedUsersRowButton = (props: {
  disabled?: boolean;
  baseChoices: AssigneeChoice[];
  assetsByCategoryId: Record<string, CertifiedAssetRow[]>;
  certifiedAssetIdsByCategoryId: Record<string, Set<string>>;
  isChoicesLoading?: boolean;
}) => {

  const record = useRecordContext();
  const translate = useTranslate();
  const refresh = useRefresh();
  const [open, setOpen] = useState(false);

  if (!record) return null;

  const categoryId = String(record.id);

  const existingUsers: ExistingCertifiedUser[] = buildExistingCertifiedUsers(
    props.assetsByCategoryId[categoryId] ?? [],
    categoryId,
  );

  const certifiedAssetIds = props.certifiedAssetIdsByCategoryId[categoryId] ?? new Set();

  const category: CertifiedUsersCategory = {
    id: String(record.id),
    name: record.name,
    validityPeriod: record.validityPeriod,
    isDocumentaryProofRequired: record.isDocumentaryProofRequired ?? false,
  };

  const isDisabled = props.disabled
    || props.isChoicesLoading
    || (props.baseChoices.length === 0 && existingUsers.length === 0);

  const button = (
    <Button
      label={translate('resources.certification-categories.text.manage_certificates', { category: category.name })}
      onClick={() => setOpen(true)}
      startIcon={<ManageAccountsIcon />}
      disabled={isDisabled}
    />
  );

  return (
    <>
      {isDisabled && !props.disabled && !props.isChoicesLoading ? (
        <Tooltip title={translate('resources.certification-categories.text.all_users_already_certified')}>
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      )}
      <AddCertifiedUsersModal
        open={open}
        onClose={() => setOpen(false)}
        onComplete={() => {

          setOpen(false);
          refresh();

        }}
        categories={[category]}
        choices={props.baseChoices}
        existingUsers={existingUsers}
        certifiedAssetIds={certifiedAssetIds}
        isChoicesLoading={props.isChoicesLoading}
        requireRecipientChanges={true}
      />
    </>
  );

};
